import { IconSize } from './constants.js';
import React from 'react';
import { ThemingContext } from '../theming/theming.js';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FallbackIcon = function FallbackIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? IconSize.Medium : _ref$size,
      iconColor = _ref.iconColor,
      useDefaultColors = _ref.useDefaultColors,
      props = _objectWithoutProperties(_ref, ["size", "iconColor", "useDefaultColors"]);

  var theme = React.useContext(ThemingContext);

  if (size <= IconSize.Small) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/React.createElement("title", null, "Missing Icon"), /*#__PURE__*/React.createElement("rect", {
      x: "4.5",
      y: "4.5",
      width: "15",
      height: "15",
      stroke: useDefaultColors ? theme.Colors.TextPrimary : iconColor,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "3 3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10.8701 13.085C10.8701 13.305 10.9801 13.58 10.9801 13.58H12.9051C12.9051 12.59 14.8301 12.315 14.8301 10.39C14.8301 9.235 13.6751 8.08 11.9701 8.08C9.66014 8.08 9.05514 9.95 9.05514 9.95L10.8151 10.775C10.8151 10.775 11.0351 10.115 11.8601 10.115C12.3001 10.115 12.5751 10.39 12.5751 10.72C12.5751 11.545 10.8701 11.611 10.8701 13.085ZM10.7601 15.12C10.7601 15.67 11.2001 16.11 11.8051 16.11C12.4101 16.11 12.8501 15.67 12.8501 15.12C12.8501 14.57 12.4101 14.13 11.8051 14.13C11.2001 14.13 10.7601 14.57 10.7601 15.12Z",
      fill: useDefaultColors ? theme.Colors.TextPrimary : iconColor
    }));
  }

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("title", null, "Missing Icon"), /*#__PURE__*/React.createElement("rect", {
    x: "1",
    y: "1",
    width: "22",
    height: "22",
    stroke: useDefaultColors ? theme.Colors.TextPrimary : iconColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7414 13.57C10.7414 13.85 10.8814 14.2 10.8814 14.2H12.7714C12.7714 12.38 15.2914 12.38 15.2914 9.79C15.2914 8.32 13.9614 6.99 11.9314 6.99C9.13137 6.99 8.43137 9.37 8.43137 9.37L10.1814 10.14C10.1814 10.14 10.5314 9.02 11.8614 9.02C12.6314 9.02 13.1214 9.51 13.1214 10.07C13.1214 11.54 10.7414 11.54 10.7414 13.57ZM10.6014 16.09C10.6014 16.65 11.0914 17.14 11.7214 17.14C12.3514 17.14 12.8414 16.65 12.8414 16.09C12.8414 15.53 12.3514 15.04 11.7214 15.04C11.0914 15.04 10.6014 15.53 10.6014 16.09Z",
    fill: useDefaultColors ? theme.Colors.TextPrimary : iconColor
  }));
};

export { FallbackIcon as default };
